import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetMissingClipsResponse } from './get-missing-clips-response';
import { getMissingClipsResponseSchema } from './get-missing-clips-response';

export async function getMissingClipsApi(
  collectionId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetMissingClipsResponse>> {
  return getRequest<IGetMissingClipsResponse>({
    path: `/sys/pipeline/${collectionId}/missing-clips`,
    schema: getMissingClipsResponseSchema,
    options,
  });
}
